export default __webpack_public_path__ + "static/media/changelog.83174444.svg";